





import { Component, Prop, Vue } from 'vue-property-decorator'
import { ILabelValue } from '@/interfaces/generic'
const ApexCharts = () => import(`vue-apexcharts`)

@Component({
  components: {
    ApexCharts
  }
})
export default class StatBarChart extends Vue {
  @Prop()
  title: string

  @Prop()
  items: ILabelValue[]

  options = {
    chart: {
      background: '#363636',
      toolbar: {
        show: false
      }
    },
    xaxis: {
      categories: this.labels
    },
    theme: {
      mode: 'dark',
      monochrome: {
        enabled: true,
        color: '#13ad13'
      }
    },
    plotOptions: {
      bar: {
        columnWidth: '50%'
      }
    },
    grid: {
      borderColor: '#444'
    }
  }

  get series(): any[] {
    return [
      {
        name: 'Tracks',
        data: this.items.map(x => x.value)
      }
    ]
  }

  get labels(): string[] {
    return this.items.map(x => x.label)
  }
}
